export default __webpack_public_path__ + "files/media/plane-mobile@2x.205df2be.jpg";